import { App } from 'vue'

export default (app: App) => {
  app.directive('focus', {
    mounted: function (el) {
      el.focus()
    }
  })
  
  // Add classes to element on scroll
  const handleScroll = (el: HTMLElement) => {
    if (el.scrollTop > 0) el.classList.add('scrollable-top')
    else el.classList.remove('scrollable-top')
    if (el.scrollHeight && el.scrollTop !== (el.scrollHeight - el.offsetHeight)) el.classList.add('scrollable-bottom')  
    else el.classList.remove('scrollable-bottom')  
  }
  app.directive('scrollable', {
    beforeMount: (el: HTMLElement) => {
      el.onscroll = () => handleScroll(el)
      el.classList.add('scrollable')
    },
    mounted: (el: HTMLElement) => {
      handleScroll(el)
    },
    updated: (el: HTMLElement) => {
      handleScroll(el)
    }
  })

  type Tooltip = {
    text: string;
    pos: 'top' | 'right';
  }

  function createTooltip(el: HTMLElement, value: any) {
    let timer: NodeJS.Timeout
    el.onmouseover = () => {
      const tooltip = document.getElementById('tooltip')!
      const position: Tooltip['pos'] = value.pos || 'top'
      const rect = el.getBoundingClientRect()
      tooltip.innerHTML = '<span>' + (value.text || value) + '</span>'
      tooltip.className = 'no-mobile tooltip-' + position + (value.large ? ' tooltip-large' : '')
      tooltip.style.opacity = '1'
      if (position == 'right') {
        tooltip.style.width = '0px'
        tooltip.style.height = rect.height + 'px'
        tooltip.style.transform = `translate(${rect.left + rect.width}px, ${rect.top}px)`        
      } else {
        tooltip.style.height = '0px'
        tooltip.style.width = rect.width + 'px'
        tooltip.style.transform = `translate(${rect.left}px, ${rect.top}px)`        
      }
      timer = setTimeout(() => {
        // tooltip.style.display = 'flex'
      }, 200)
    }
    el.onmouseout = () => {
      const tooltip = document.getElementById('tooltip')!
      tooltip.style.opacity = '0'
      clearTimeout(timer)
    }
  }

  app.directive('tooltip', {
    mounted: (el: HTMLElement, { value }) => {
      createTooltip(el, value)
    },
    updated: (el: HTMLElement, { value }) => {
      //const tooltip = document.getElementById('tooltip')!
      //tooltip.innerHTML = '<span>' + (value.text || value) + '</span>'
      createTooltip(el, value)
    }
  })
}

